<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Employee Attendance
    </div>
    <form name="ApprovalDetails" (ngSubmit)="Validate(ApprovalDetails)" #ApprovalDetails="ngForm" class="pb-2"
        novalidate>
        <div class="card-body">
            <div class="row d-flex">
                <div class="col-md-3 px-1">
                    <label class="Label"> From Date <span class="text-danger">*</span></label>
                    <div class="input-group">
                        <input class="form-control" placeholder="yyyy-mm-dd" name="fromdate "
                            placeholder="Ex. DD/MM/YYYY" [(ngModel)]="Filter.FromDateObj"
                            (ngModelChange)="onFromDateChange();onSelectChange('from');clear()" #HolidayDate="ngModel"
                            ngbDatepicker #d="ngbDatepicker" [ngModelOptions]="{standalone: true}" readonly
                            [minDate]="minFromDate" [maxDate]="maxFromDate" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()"
                            type="button"></button>
                        <div class="invalid-feedback">
                            Please enter from date !
                        </div>
                    </div>
                </div>
                <div class="col-md-3 px-1">
                    <label class="Label"> To Date <span class="text-danger">*</span></label>
                    <div class="input-group">
                        <input class="form-control" placeholder="yyyy-mm-dd" name="todate " placeholder="Ex. DD/MM/YYYY"
                            [(ngModel)]="Filter.ToDateObj" (ngModelChange)="onToDateChange();onSelectChange('to');clear()"
                            #HolidayDate="ngModel" ngbDatepicker #d1="ngbDatepicker"
                            [ngModelOptions]="{standalone: true}" readonly [minDate]="minToDate"
                            [maxDate]="maxToDate" />

                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d1.toggle()"
                            type="button"></button>
                        <div class="invalid-feedback">
                            Please enter from date !
                        </div>
                    </div>
                </div>
                <div class="col-md-5 px-1">
                    <label class="form-font-label">Branch <span class="text-danger">*</span></label>
                    <ng-select name="Branchmaster" id="Branchmaster" [items]="BranchMaster" bindLabel="BranchName"
                        bindValue="BranchMasterID" [(ngModel)]="Filter.BranchId"
                        (change)="ComboLoad('Client');onSelectChange('Branch');clear()" #Branchmaster="ngModel"
                        placeholder="Select Branch">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Branch!
                    </div>
                </div>
                <div class="col-md-5 px-1">
                    <label class="form-font-label">Client<span class="text-danger">*</span></label>
                    <ng-select name="Client" id="Client" [items]="ClientMaster" bindLabel="ClientGroupName"
                        bindValue="ClientGroupMasterID" (change)="ComboLoad('Site');onSelectChange('Client');clear()"
                        [(ngModel)]="Filter.ClientId" #Branch="ngModel" placeholder="Select Client">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Client!
                    </div>
                </div>
                <div class="col-md-6 px-1">
                    <label class="form-font-label">Site<span class="text-danger">*</span></label>
                    <ng-select name="Site" id="Site" [items]="SiteMaster" bindLabel="SiteName" bindValue="SiteMasterID"
                        [(ngModel)]="Filter.SiteId" #Branch="ngModel" (change)="onSelectChange('Site');clear()"
                        placeholder="Select Site">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Site!
                    </div>
                </div>
                <div class="col-md-3 px-1">
                    <label>Emp Code <span class="text-danger">*</span></label>
                    <input name="Code" maxlength="100" class="form-control" placeholder="Ex."
                        [(ngModel)]="Filter.EmpCode" #Code="ngModel">
                    <div class="invalid-feedback">
                        Please enter Code.
                    </div>
                </div>
                <div class="col-md-2 px-1 d-flex align-items-end">
                    <button *ngIf="this.common.PageRight.IsPrint" type="submit" name="submit1" class="btn btn-primary"
                        [disabled]="isDisabled">
                        <i class="bi bi-search" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled ? 'Search' : 'Loading...'}}
                    </button>
                </div>
            </div>
            <hr>
            <!-- <table datatable [dtOptions]="dtoptions" [dtTrigger]="dtTrigger" class="table table-bordered pt-2"
                style="width: 100%; overflow: auto;">
                <thead class="table-light">
                    <tr>
                        <th>#</th>
                        <th>View</th>
                        <th>Employee</th>
                        <th>Branch Name</th>
                        <th>Client Name</th>
                        <th>Site Code</th>
                        <th>Site Name</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="width: 5px;">
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%; border: none;"
                                name="act{{i}}" (click)="onViewClick(TableData)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                        <td>
                            <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                                <div class="col-2">
                                    <img *ngIf="TableData['Photo'] != null && TableData['Photo'] != ''" mat-card-image
                                        class="userImage" [src]="common.PhotoLink(TableData['Photo'])" />
                                    <div *ngIf="TableData['Photo'] == null || TableData['Photo'] == ''"
                                        class="initial-image">
                                        <div class="image">
                                            {{common.getInitial(TableData['EmpName'])}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-9 userdetail">
                                    <span class="text-label-dark">{{TableData['EmpName']}}</span><br />
                                    <span class="text-label-light">#{{TableData['EmpCode']}}</span><br />
                                    <span class="text-label-light">{{TableData['DesignationName']}}</span>
                                </div>
                            </div>
                        </td>
                        <td>{{TableData['BranchName']}}</td>
                        <td>{{TableData['ClientName']}}</td>
                        <td>{{TableData['SiteCode']}}</td>
                        <td>{{TableData['SiteName']}}</td>
                    </tr>
                </tbody>
            </table> -->
            <table  class="customeDatatable table table-bordered pt-2">
                <thead class="table-light">
                    <tr>
                        <th>#</th>
                        <th>View</th>
                        <th>Employee</th>
                        <th>Branch Name</th>
                        <th>Client Name</th>
                        <th>Site Code</th>
                        <th>Site Name</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let TableData of TableDatas; let i = index">
                        <!-- Main Row -->
                        <tr>
                            <th scope="row">{{ i + 1 }}</th>
                            <td>
                                <button type="button" (click)="onViewClick(TableData,i)"
                                    class="btn btn-lg btn-group-toggle" name="act{{i}}"
                                    style="border: none;">
                                    <i [ngClass]="{
                                        'bi': true,
                                        'bi-plus btn-primary': expandedIndex !== i,
                                        'bi-dash-square text-success btn-lg': expandedIndex === i
                                      }"></i>
                                </button>
                            </td>
                            <td>
                                <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                                    <div class="col-2">
                                        <img *ngIf="TableData['Photo'] != null && TableData['Photo'] != ''"
                                            mat-card-image class="userImage"
                                            [src]="common.PhotoLink(TableData['Photo'])" />
                                        <div *ngIf="TableData['Photo'] == null || TableData['Photo'] == ''"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(TableData['EmpName'])}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-9 userdetail">
                                        <span class="text-label-dark">{{TableData['EmpName']}}</span><br />
                                        <span class="text-label-light">#{{TableData['EmpCode']}}</span><br />
                                        <span class="text-label-light">{{TableData['DesignationName']}}</span>
                                    </div>
                                </div>
                            </td>
                            <td>{{TableData.BranchName}}</td>
                            <td>{{TableData.ClientName}}</td>
                            <td>{{TableData.SiteCode}}</td>
                            <td>{{TableData.SiteName}}</td>
                        </tr>

                        <!-- Level 1 Expandable Row -->
                        <tr *ngIf="expandedIndex === i">
                            
                            <td colspan="7">
                                <table class="customeDatatable table-sm">
                                    <thead class="table-light">
                                        <tr>
                                            <th>View</th>
                                            <th>Attendance Date</th>
                                            <th>In Time</th>
                                            <th>Out Time</th>
                                            <th>Attendance Type</th>
                                            <th>Working Hour</th>
                                            <th>Shift Title</th>
                                            <th>Shift Start</th>
                                            <th>Shift End</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngFor="let detail of TableDatas2; let j = index">
                                            <tr>
                                                <td>
                                                    <button type="button" (click)="onSubViewClick(TableData ,j,detail)"
                                                        class="btn btn-lg btn-group-toggle" name="act1{{j}}"
                                                        style="height: 50%; border: none;">
                                                        <i [ngClass]="{
                                                            'bi': true,
                                                            'bi-plus btn-primary': subExpandedIndex !== j,
                                                            'bi-dash-square text-success': subExpandedIndex === j
                                                          }"></i>
                                                    </button>
                                                </td>
                                                <td>{{detail.AttendanceDate | date: 'dd MMM yyyy'}}</td>
                                                <td>{{detail.InTime | date: 'HH:mm'}}</td>
                                                <td>{{detail.OutTime | date: 'HH:mm'}}</td>
                                                <td>{{detail.AttendanceType}}</td>
                                                <td>{{detail.WorkingHour}}</td>
                                                <td>{{detail.ShiftTitle}}</td>
                                                <td>{{detail.ShiftStart}}</td>
                                                <td>{{detail.ShiftEnd}}</td>
                                            </tr>

                                            <!-- Level 2 Expandable (Punch Detail) -->
                                            <tr *ngIf="subExpandedIndex === j">
                                                <td colspan="9">
                                                    <table class="customeDatatable table-sm">
                                                        <thead class="table-light">
                                                            <tr>
                                                                <th>Time</th>
                                                                <th>Date</th>
                                                                <th>Attendance Status</th>
                                                                <th>Punched Through</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let punch of TableDatas3">
                                                                <td>{{punch.Time | date: 'HH:mm:ss'}}</td>
                                                                <td>{{punch.Time | date: 'dd MMM yyyy'}}</td>
                                                                <td>{{punch.AttendanceStatus}}</td>
                                                                <td>{{punch.PunchedThrough}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>

                                        </ng-container>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>

        </div>
    </form>
</div>